import React, { useRef, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import {
  FileUploadContainer,
  FormField,
  DragDropText,
  UploadFileBtn,
  FilePreviewContainer,
  ImagePreview,
  PreviewContainer,
  PreviewList,
  FileMetaData,
  RemoveFileIcon,
  InputLabel,
} from './file-upload.styles';

const KILO_BYTES_PER_BYTE = 1000;
const DEFAULT_MAX_FILE_SIZE_IN_BYTES = 8000000;

const convertNestedObjectToArray = (nestedObj) =>
  Object.keys(nestedObj).map((key) => nestedObj[key]);

const convertBytesToKB = (bytes) => Math.round(bytes / KILO_BYTES_PER_BYTE);

const FileUpload = ({
  label,
  updateFilesCb,
  maxFileSizeInBytes = DEFAULT_MAX_FILE_SIZE_IN_BYTES,
  filenamePrefix,
  title,
  index,
  callback, //frontBack, index
  frontBack,
  hidePreviewPane = false,
  thin,
  ...otherProps
}) => {
  const fileInputField = useRef(null);
  const [files, setFiles] = useState({});
  // alert(filenamePrefix);
  const handleUploadBtnClick = () => {
    fileInputField.current.click();
  };

  const addNewFiles = (newFiles) => {
    for (let file of newFiles) {
      if (file.size <= maxFileSizeInBytes) {
        if (!otherProps.multiple) {
          return { file };
        }
        files[file.name] = file;
      }
    }
    return { ...files };
  };

  const callUpdateFilesCb = async (files) => {
    const filesAsArray = convertNestedObjectToArray(files);
    await updateFilesCb(filesAsArray, filenamePrefix);
    callback(frontBack, index);
  };

  const handleNewFileUpload = async (e) => {
    const { files: newFiles } = e.target;
    if (newFiles.length) {
      let updatedFiles = addNewFiles(newFiles);
      setFiles(updatedFiles);
      await callUpdateFilesCb(updatedFiles);
    }
  };

  const removeFile = (fileName) => {
    delete files[fileName];
    setFiles({ ...files });
    callUpdateFilesCb({ ...files }, filenamePrefix);
  };

  return (
    <>
      <FileUploadContainer style={{ paddingTop: '5px', paddingBottom: '5px', paddingLeft: thin ? 5 : 20, paddingRight: thin ? 5 : 20 }}>
        <DragDropText style={thin ? { letterSpacing: 0 } : {}}>{title || 'Upload a file'}</DragDropText>
        <UploadFileBtn style={thin ? { fontSize: '0.8rem', paddingRight: 12 } : {}} type='button' onClick={handleUploadBtnClick}>
          {/*
            https://fontawesome.com/v5.15/icons?d=gallery&p=2&q=upload

            - Smeni gi klasite ako sakas da smenis ikona
          */}
          <i className='fas fa-file-upload' />
          <span>
            <FormattedMessage id='uploadAFile' />
          </span>
        </UploadFileBtn>
        <FormField
          type='file'
          ref={fileInputField}
          onChange={handleNewFileUpload}
          title=''
          value=''
          {...otherProps}
        />
      </FileUploadContainer>

      {hidePreviewPane &&
        <>
          {Object.keys(files).map((fileName, index) => {
            let file = files[fileName];
            let isImageFile = file.type.split('/')[0] === 'image';
            return (<div className='flexbox-container-horiz-no-border'>
              {file.name}
            </div>)
          })}
        </>
      }

      {!hidePreviewPane &&
        <FilePreviewContainer >
          <PreviewList>
            {Object.keys(files).map((fileName, index) => {
              let file = files[fileName];
              let isImageFile = file.type.split('/')[0] === 'image';
              return (
                <PreviewContainer key={fileName}>
                  <div>
                    {isImageFile && (
                      <ImagePreview
                        src={URL.createObjectURL(file)}
                        alt={`file preview ${index}`}
                      />
                    )}
                    <FileMetaData isImageFile={isImageFile}>
                      <span>{file.name}</span>
                      <aside>
                        <span>{convertBytesToKB(file.size)} kb</span>
                        <RemoveFileIcon
                          className='fas fa-trash-alt'
                          onClick={() => removeFile(fileName)}
                        />
                      </aside>
                    </FileMetaData>
                  </div>
                </PreviewContainer>
              );
            })}
          </PreviewList>
        </FilePreviewContainer>
      }
    </>
  );
};

export default FileUpload;
